
import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'


import { CasinoLink } from '../../Components/Layout/CasinoLink.jsx'
import { Wallet2 } from '../../Components/Account/Wallet2.jsx'
import { AccountLinkovi } from '../../Components/Account/AccountLinkovi.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

//import { DatePicker } from '../../Components/Layout/DatePicker.jsx'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import hr from 'date-fns/locale/hr';
registerLocale('hr', hr);

export class AccountTransactions extends React.Component {

    constructor(props) {
        super(props);

        this.submitForm = this.submitForm.bind(this);
        this.setData = this.setData.bind(this);
        this.setTranTypes = this.setTranTypes.bind(this);
        this.fetchMore = this.fetchMore.bind(this);
        this.state = {
            to: new Date(),
            from: casino.utils.addDays(new Date(), -7),
            type: 0,
            working: false,
            data: null,
            page: 1,
            types: null,
            fromSport: false
        };

        this.props.showLoadingFn(true);
        this.fetchTranTypes();
        casino.utils.createPageGoogleTagManagerEvent('Moj Racun', 'Transakcije', 'casino', this.props.user);
    }

    componentDidMount() {
        const sportParam = new URLSearchParams(location.search).get("fromsport");
        if (sportParam && sportParam == "1") {
            this.setState({ fromSport: true });
        }

        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    fetchTranTypes() {
        var promises = Promise.all([casino.repos.transactionTypesRepo.list()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setTranTypes, function (reason) { });
    }

    setTranTypes(data) {
        this.setState({ types: data[0] });
        this.props.showLoadingFn(false);

    }
    componentWillUnmount() {
        this.props.showLoadingFn(false);
        this.dataPromises.cancel();
    }

    setData(data) {
        this.setState({ data: data[0], page: 1 })
    }


    submitForm(e) {
        var that = this;

        e.preventDefault();
        this.props.showLoadingFn(true);
        this.setState({ working: true, page: 1 })

        casino.repos.playerTransactionsRepo.list(casino.utils.dateToIso(this.state.from), casino.utils.dateToIso(this.state.to), this.state.type, 1).then(function (data) {
            that.setState({ working: false, data: data.items, hasMore: data.hasMore })
            that.props.showLoadingFn(false);
        });

    }
    fetchMore() {
        var that = this;
        this.props.showLoadingFn(true);
        var page = (this.state.page + 1)
        this.setState({ working: true });

        casino.repos.playerTransactionsRepo.list(casino.utils.dateToIso(this.state.from), casino.utils.dateToIso(this.state.to), this.state.type, page).then(function (data) {
            that.setState({ working: false, data: that.state.data.concat(data.items), hasMore: data.hasMore, page: page })
            that.props.showLoadingFn(false);
        });

    }


    renderTran(x) {
        return <tr key={x.transactionId + x.datum} className="horizontal-lines">
            <td><span className="text text-1  text-left">{casino.utils.dateToDateString(new Date(x.datum))} {casino.utils.dateToTimeString(new Date(x.datum))}</span></td>
            <td><span className="text text-1  text-left ">{x.vrsta}</span></td>
            <td className="text-right text text-1 text-bold">
                <div className="main-currency">{casino.utils.numberWithCurrencyFromated(x.iznos, x.valuta)}</div>
            </td>
            <td className="text-center text text-1 "><span style={{ lineHeight: "35px" }}>{x.statusText}</span></td>
        </tr>


    }



    render() {
        var pathName = this.props.route.match.url;
        var user = this.props.user;

        if (this.props.user) {
            return <div>

                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}

                <MetaTags title="Transakcije | SuperSport Casino" description={" "} />
                <Route exact path={pathName} render={(route) =>
                    (<Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText={"Transakcije"} headerBackUrl={this.props.getHomePathFn(this.props.route.location, '/account')}></Header>)} />
                <div className="flex margin-1p-on-tablet">
                    {!this.state.fromSport && <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>}

                    <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding" style={{ minHeight: '400px' }}>




                        <div className="header-2">
                            <h1 className="text">Transakcije</h1>
                        </div>
                        <div className="clearfix flex-equal-size maximum">
                            <div className="" style={{ minHeight: '600px' }}>
                                <div className="padding-sides-medium ">

                                    <form onSubmit={this.submitForm} >

                                        <div className="input-group v2 v5 margin-top-small clearfix">

                                            <select required className="input-group--input " value={this.state.type} onChange={(e) => this.setState({ type: e.target.value })} >
                                                {this.state.types && Object.keys(this.state.types).map(
                                                    x => <option key={x} value={x}>{this.state.types[x]}</option>
                                                )}

                                            </select>

                                            <span className="input-group--prefix">Tip:</span>
                                            <span className="input-group--suffix"></span>
                                        </div>

                                        <div className="input-group v2  v5 margin-top-small clearfix">
                                            <DatePicker dateFormat="dd.MM.yyyy." calendarStartDay={1} className="input-group--input date-picker" locale="hr" selected={this.state.from} onChange={(date) => this.setState({ from: date })} />
                                            <span className="input-group--prefix">Datum od:</span>
                                            <span className="input-group--suffix"></span>
                                        </div>

                                        <div className="input-group v2  v5 margin-top-small clearfix">
                                            <DatePicker dateFormat="dd.MM.yyyy." calendarStartDay={1} className="input-group--input date-picker" locale="hr" selected={this.state.to} onChange={(date) => this.setState({ to: date })} />
                                            <span className="input-group--prefix">Datum do:</span>
                                            <span className="input-group--suffix"></span>
                                        </div>

                                        <div className="margin-top margin-bottom"></div>
                                        <div className="margin-top">
                                            <div >
                                                <button type="submit" disabled={this.state.working} className="as-block btn fill large gray-blue">Prikaži</button>
                                            </div>

                                        </div>


                                        <div className="margin-top margin-bottom"></div>
                                    </form>
                                    <br />
                                    <hr />
                                    <br />
                                    <b className="text">Transakcije:</b>
                                    <br />
                                    <br />

                                    {!this.state.data && <span className="text">Pritisnite prikaži za početak...</span>}
                                    {this.state.data && this.state.data.length == 0 && <span className="text">Nisu pronađene tranakcije.</span>}
                                </div>
                                {this.state.data && this.state.data.length > 0 &&
                                    <table className="table-1 v2 v3 player-transactions">
                                        <thead><tr>
                                            <th className="  text-left text text-6 ">Datum</th>
                                            <th className="text-left text text-6">Transakcija</th>
                                            <th className="text-right text text-6">Iznos</th>
                                            <th className="text-center text text-6">Status</th>
                                        </tr></thead>
                                        <tbody>

                                            {this.state.data.map(this.renderTran.bind(this))}
                                        </tbody>
                                    </table>
                                }


                                {this.state.hasMore &&
                                    <div className="text-center" >
                                        <br></br>
                                        <button disabled={this.state.working} className="btn fill medium gray-blue" onClick={this.fetchMore}>Učitaj još...</button>
                                        <br></br>

                                    </div>

                                }


                                {this.state.data && this.state.data.length > 0 &&
                                    <div className="padding-sides-medium margin-top text-center">
                                        <span style={{ fontStyle: 'italic', fontSize: '12px' }}>
                                            *detalje možete ispisati na vašem računalu</span>
                                    </div>
                                }

                                <br></br>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        } else {
            return <div>
                <Header key="header" {...this.state} {...this.props}></Header>
                <RestrictedAccess {...this.props} />


                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}


            </div>

        }

    }
};
